/*
 * Muñequita Vintage — weighted wheel-scroll momentum.
 *
 * Dawn's default scroll is the browser's native, immediate wheel scroll.
 * This intercepts mouse-wheel input on desktop and eases the page toward
 * the target position instead of snapping to it, so scrolling feels
 * slower to settle and "heavier" — a common premium/editorial-site touch.
 *
 * Deliberately narrow in scope:
 * - Desktop mouse-wheel only. Touch devices already have great native
 *   momentum scrolling; hijacking touch scroll is a common source of
 *   janky, laggy-feeling mobile sites, so this backs off entirely there.
 * - Respects prefers-reduced-motion.
 * - Leaves scroll native (does not call preventDefault) inside anything
 *   that looks like its own scrollable overlay — cart/menu drawers,
 *   dialogs/modals, dropdown panels, predictive search, form controls —
 *   so those keep working exactly as before.
 * - Uses window.scrollTo (not a transformed wrapper), so position:sticky
 *   elements, anchor links, and keyboard/scrollbar scrolling all keep
 *   working normally; this only changes how wheel input feels.
 */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if (window.matchMedia('(pointer: coarse)').matches) return;

  var EASE = 0.09; // lower = slower to settle = "heavier"
  var SETTLE_THRESHOLD = 0.5;
  var LINE_HEIGHT_PX = 16; // approximation for line-mode wheel deltas

  var current = window.scrollY;
  var target = window.scrollY;
  var animating = false;

  function maxScroll() {
    return Math.max(0, document.documentElement.scrollHeight - window.innerHeight);
  }

  function isInsideScrollableOverlay(el) {
    if (!el || typeof el.closest !== 'function') return false;
    return !!el.closest(
      [
        '[class*="drawer"]',
        '[class*="modal"]',
        '[role="dialog"]',
        '[aria-modal="true"]',
        '.disclosure__list-wrapper',
        '.predictive-search',
        '.search-modal',
        'select',
        'textarea',
        'input',
        '[data-scroll-lock-scrollable]',
      ].join(',')
    );
  }

  function onWheel(event) {
    if (isInsideScrollableOverlay(event.target)) return;

    var deltaY = event.deltaY;
    if (event.deltaMode === 1) deltaY *= LINE_HEIGHT_PX;
    else if (event.deltaMode === 2) deltaY *= window.innerHeight;

    event.preventDefault();

    target = Math.max(0, Math.min(maxScroll(), target + deltaY));

    if (!animating) {
      animating = true;
      requestAnimationFrame(step);
    }
  }

  function step() {
    current += (target - current) * EASE;

    if (Math.abs(target - current) < SETTLE_THRESHOLD) {
      current = target;
      window.scrollTo(0, current);
      animating = false;
      return;
    }

    window.scrollTo(0, current);
    requestAnimationFrame(step);
  }

  // Stay in sync with scroll that didn't come from our own wheel handler
  // (keyboard, scrollbar drag, anchor links, browser back/forward).
  var syncTimer;
  function syncFromNativeScroll() {
    if (animating) return;
    clearTimeout(syncTimer);
    syncTimer = setTimeout(function () {
      current = window.scrollY;
      target = window.scrollY;
    }, 120);
  }

  window.addEventListener('wheel', onWheel, { passive: false });
  window.addEventListener('scroll', syncFromNativeScroll, { passive: true });
  window.addEventListener('resize', function () {
    target = Math.max(0, Math.min(maxScroll(), target));
  });
})();
